<div class="get-it-modal-dialog p-4" data-automation-id="get-it-modal-dialog">
  <app-modal-header
    title="{{ 'requestOptions' | translate }}"
    titleId="get-it-modal-title"
    closeId="close-get-it-dialog-btn"
    (close)="onClose()"
  >
  </app-modal-header>
  <div class="modal-body">
    <form [formGroup]="getItForm" class="get-it-form" (ngSubmit)="onSubmit()">
      <app-pickup-location-select
        formControlName="pickupLocation"
        [pickupLocations]="pickupLocations"
        [isCRI]="isCRI"
        [selectedLocationCode]="selectedLocationCode"
        (codeChanging)="changePickupLocation($event)"
        [dataAutomationId]="'pickupLocationDropdown'"
      >
      </app-pickup-location-select>
      <app-pickup-volume-select
        *ngIf="volumes?.length"
        formControlName="volume"
        [volumes]="volumes"
        [selectedVolumeCode]="selectedLocationCode"
        (codeChanging)="changeVolume($event)"
        [dataAutomationId]="'volumeDropdown'"
      >
      </app-pickup-volume-select>
      <label
        id="note-label"
        for="note-location"
        data-automation-id="note-label"
        class="note__label"
      >
        {{ "note" | translate }}
      </label>
      <input
        formControlName="note"
        [attr.aria-invalid]="noteControl.invalid && noteControl.touched"
        [class.is-invalid]="noteControl.invalid && noteControl.touched"
        class="note-input"
        aria-labelledby="edit-note"
        aria-required="false"
        data-automation-id="edit-note"
        placeholder="{{ 'writeNote' | translate }}"
        type="text"
      />
      <p translate class="highlighted-text">getChapterRequest</p>
      <section class="actions mt-4">
        <div class="buttons">
          <button
            type="button"
            class="ins-buttons button-secondary flint reset-button"
            (click)="onReset()"
            [disabled]="isLoading$ | async"
            data-automation-id="cancel-get-it-btn"
          >
            <span translate>reset</span>
            <img src="../../../../assets/reset.svg" [attr.alt]="'reset' | translate" class="btn-icon" />
          </button>
          <button
            class="ins-buttons button-primary flint"
            type="submit"
            [disabled]="isFormDisabled || (this.isLoading$ | async)"
            data-automation-id="confirm-get-it-btn"
          >
            <span translate>send</span>
            <img src="../../../../assets/send.svg" [attr.alt]="'send' | translate" class="btn-icon"/>
          </button>
        </div>
      </section>
    </form>
  </div>
</div>
